(function() {
'use strict';

const inTestingEnvironment = typeof __karma__ !== 'undefined';

function decorate(service, $provide, $injector) {
    if (!$injector.has(service)) {
        return;
    }

    $provide.decorator(service, ['$delegate', '$q', function($delegate, $q) {
        const newService = inTestingEnvironment ? $delegate : Object.assign({}, $delegate);
        for (const fnName in $delegate) {
            const fn = $delegate[fnName];
            newService[fnName] = function(...args) {
                const res = fn(...args);
                return !inTestingEnvironment && res instanceof Promise ? $q.when(res) : res;
            };
        }
        return newService;
    }]);
}

angular
    .module('TR')
    .config(['$provide', '$injector', function($provide, $injector) {
        [
            'agentModeService',
            'animationUtil',
            'basketCrossSellService',
            'cmsService',
            'destinationAirport',
            'discountsService',
            'flightDetail',
            'flightSeatPlanService',
            'flightStaticService',
            'globalisationService',
            'googleStaticMap',
            'hotelStaticMapService',
            'languageService',
            'localStorageProvider',
            'loggingService',
            'postcodeService',
            'primaryNavigationService',
            'productService',
            'publicityService',
            'scrollService',
            'urgencyMessaging'
        ].forEach(service => decorate(service, $provide, $injector));
    }]);

angular
    .module('core')
    .config(['$provide', '$injector', function($provide, $injector) {
        [
            'adHocService',
            'flightsTerminalService'
        ].forEach(service => decorate(service, $provide, $injector));
    }]);
})();
